import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue";

var _hoisted_1 = /*#__PURE__*/_createVNode("a", {
  href: "https://anyway.fm/",
  style: {
    "text-decoration": "none",
    "color": "inherit"
  }
}, "企业微信报表", -1);

var _hoisted_2 = /*#__PURE__*/_createTextVNode("保存");

import { ref, reactive, nextTick, onMounted } from 'vue';
import request from '@/plugin/request';
import { NPageHeader, NButton, NSpace, NAvatar } from 'naive-ui';
import { useRoute, useRouter } from "vue-router";
export default _defineComponent({
  setup: function setup(__props) {
    nextTick(function () {});
    onMounted(function () {
      request('/mobile/dict', {}, {
        method: 'get'
      }).then(function (response) {
        selectOptions.userList = response.result.userList;
        selectOptions.shopList = response.result.shopList;
      });
      handleReload();
    });
    var route = useRoute();
    var router = useRouter();

    var handleBack = function handleBack() {
      router.go(-1);
    };

    var handleReload = function handleReload() {
      request('/mobile', {}, {
        method: 'get'
      }).then(function (response) {
        if (response.result) {
          var xgrid = grid.value;
          xgrid.reloadData(response.result.rows);
        }
      });
    };

    var grid = ref({});
    var gridOptions = reactive({
      align: 'center',
      columns: [{
        type: 'seq',
        width: 60,
        fixed: 'left'
      }, {
        field: 'userid',
        title: '编码',
        minWidth: 160
      }, {
        field: 'name',
        title: '名称',
        minWidth: 160
      }, {
        field: 'permissionName',
        title: '数据权限',
        minWidth: 160
      }, {
        field: 'operation',
        title: '操作',
        slots: {
          "default": 'operation'
        }
      }],
      toolbarConfig: {
        custom: true,
        slots: {
          buttons: 'toolbar_buttons',
          tools: 'toolbar_tools'
        }
      },
      params: {
        toolbar: {
          add: function add() {
            modalOptions.form.data = {};
            modalOptions.visible = true;
          }
        },
        operation: {
          update: function update(row) {
            modalOptions.form.data = {};
            modalOptions.form.data = row;
            modalOptions.visible = true;
          },
          remove: function remove(row) {
            request('/mobile', row, {
              method: 'DELETE'
            }).then(function (response) {
              return handleReload();
            });
          }
        }
      }
    });
    var modalForm = ref({});
    var modalOptions = reactive({
      visible: false,
      form: {
        data: {},
        titleColon: true,
        rules: {
          userid: [{
            required: true,
            message: '必填项'
          }],
          permission: [{
            required: true,
            message: '必填项'
          }]
        }
      },
      method: {
        submit: function submit() {
          var form = modalForm.value;
          console.log(form);
          form.validate().then(function () {
            request('/mobile', form.data, {
              method: 'post'
            }).then(function (response) {
              handleReload();
              modalOptions.visible = false;
            });
          });
        },
        close: function close() {
          modalOptions.visible = false;
        }
      }
    });
    var selectOptions = reactive({
      userList: [],
      shopList: []
    });
    return function (_ctx, _cache) {
      var _component_vxe_button = _resolveComponent("vxe-button");

      var _component_vxe_grid = _resolveComponent("vxe-grid");

      var _component_el_select_v2 = _resolveComponent("el-select-v2");

      var _component_vxe_form_item = _resolveComponent("vxe-form-item");

      var _component_el_option = _resolveComponent("el-option");

      var _component_el_select = _resolveComponent("el-select");

      var _component_vxe_form = _resolveComponent("vxe-form");

      var _component_vxe_modal = _resolveComponent("vxe-modal");

      return _openBlock(), _createBlock("div", null, [_createVNode(_unref(NPageHeader), {
        subtitle: "权限配置",
        onBack: handleBack
      }, {
        title: _withCtx(function () {
          return [_hoisted_1];
        }),
        avatar: _withCtx(function () {
          return [_createVNode(_unref(NAvatar), {
            src: "https://cdnimg103.lizhi.fm/user/2017/02/04/2583325032200238082_160x160.jpg"
          })];
        }),
        extra: _withCtx(function () {
          return [_createVNode(_unref(NSpace), null, {
            "default": _withCtx(function () {
              return [_createVNode(_unref(NButton), {
                type: "success"
              }, {
                "default": _withCtx(function () {
                  return [_hoisted_2];
                }),
                _: 1
              })];
            }),
            _: 1
          })];
        }),
        _: 1
      }), _createVNode(_component_vxe_grid, _mergeProps(_unref(gridOptions), {
        ref: grid,
        style: {
          "margin-top": "10px"
        }
      }), {
        toolbar_buttons: _withCtx(function () {
          return [_createVNode(_component_vxe_button, {
            status: "success",
            size: "mini",
            content: "新增",
            onClick: _cache[1] || (_cache[1] = function ($event) {
              return _unref(gridOptions).params.toolbar.add();
            })
          })];
        }),
        toolbar_tools: _withCtx(function () {
          return [];
        }),
        name: _withCtx(function (_ref) {
          var row = _ref.row;
          return [_createTextVNode(_toDisplayString(row.userid), 1)];
        }),
        operation: _withCtx(function (_ref2) {
          var row = _ref2.row;
          return [_createVNode(_component_vxe_button, {
            size: "mini",
            content: "修改",
            status: "warning",
            onClick: function onClick($event) {
              return _unref(gridOptions).params.operation.update(row);
            }
          }, null, 8, ["onClick"]), _createVNode(_component_vxe_button, {
            size: "mini",
            content: "删除",
            status: "danger",
            onClick: function onClick($event) {
              return _unref(gridOptions).params.operation.remove(row);
            }
          }, null, 8, ["onClick"])];
        }),
        _: 1
      }, 16), _createVNode(_component_vxe_modal, {
        modelValue: _unref(modalOptions).visible,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
          return _unref(modalOptions).visible = $event;
        }),
        width: "50%",
        title: "操作",
        height: "50%"
      }, {
        "default": _withCtx(function () {
          return [_createVNode(_component_vxe_form, _mergeProps(_unref(modalOptions).form, {
            ref: modalForm
          }), {
            "default": _withCtx(function () {
              return [_createVNode(_component_vxe_form_item, {
                title: "名称",
                field: "userName",
                span: "24",
                "item-render": {}
              }, {
                "default": _withCtx(function (_ref3) {
                  var data = _ref3.data;
                  return [_createVNode(_component_el_select_v2, {
                    modelValue: data.userid,
                    "onUpdate:modelValue": function onUpdateModelValue($event) {
                      return data.userid = $event;
                    },
                    options: _unref(selectOptions).userList,
                    style: {
                      "width": "100%"
                    },
                    size: "small",
                    filterable: "",
                    clearable: ""
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])];
                }),
                _: 1
              }), _createVNode(_component_vxe_form_item, {
                title: "数据权限",
                field: "permission",
                span: "24",
                "item-render": {}
              }, {
                "default": _withCtx(function (_ref4) {
                  var data = _ref4.data;
                  return [_createVNode(_component_el_select, {
                    modelValue: data.permission,
                    "onUpdate:modelValue": function onUpdateModelValue($event) {
                      return data.permission = $event;
                    },
                    filterable: "",
                    multiple: "",
                    clearable: "",
                    style: {
                      "width": "100%"
                    },
                    size: "small"
                  }, {
                    "default": _withCtx(function () {
                      return [(_openBlock(true), _createBlock(_Fragment, null, _renderList(_unref(selectOptions).shopList, function (item) {
                        return _openBlock(), _createBlock(_component_el_option, {
                          key: item.value,
                          label: item.label,
                          value: item.value,
                          disabled: item.disabled
                        }, null, 8, ["label", "value", "disabled"]);
                      }), 128))];
                    }),
                    _: 2
                  }, 1032, ["modelValue", "onUpdate:modelValue"])];
                }),
                _: 1
              }), _createVNode(_component_vxe_form_item, {
                align: "center",
                span: "24"
              }, {
                "default": _withCtx(function () {
                  return [_createVNode(_component_vxe_button, {
                    status: "primary",
                    content: "提交",
                    onClick: _unref(modalOptions).method.submit
                  }, null, 8, ["onClick"]), _createVNode(_component_vxe_button, {
                    content: "关闭",
                    onClick: _unref(modalOptions).method.close
                  }, null, 8, ["onClick"])];
                }),
                _: 1
              })];
            }),
            _: 1
          }, 16)];
        }),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }
});